import React from 'react';

import useGetMetadataMap from '@/app/metadata/hooks/useGetMetadataMap';

/**
 * 메타데이터 Map을 주입합니다.
 *
 * FIXME: 앱처럼 반드시 존재하는 쿼리 데이터처럼 고칩니다.
 */
export const MetadataMapProvider = ({ children }: { children: React.ReactNode }) => {
  const metadataResult = useGetMetadataMap({ language: 'ko' });

  const metadataMap = React.useMemo(() => {
    if (!metadataResult.data) {
      return null;
    }

    return {
      metadataMap: metadataResult.data,
      refetch: metadataResult.refetch,
    };
  }, [metadataResult.data, metadataResult.refetch]);

  if (metadataResult.isLoading) {
    return null; // 로딩 표시
  }

  if (metadataResult.isError) {
    return null; // 에러 표시
  }

  if (metadataMap == null) {
    return null;
  }

  return <MetadataMapContext.Provider value={metadataMap}>{children}</MetadataMapContext.Provider>;
};

const MetadataMapContext = React.createContext<{
  metadataMap: Record<string, string>;
  refetch: ReturnType<typeof useGetMetadataMap>['refetch'];
} | null>(null);

/**
 * 메타데이터 Map을 가져옵니다.
 */
export const useMetadataMap = () => {
  const metadataMap = React.useContext(MetadataMapContext);
  if (!metadataMap) {
    throw new Error('"useMetadataMap" was NOT used in "MetadataMapProvider" component.');
  }
  return metadataMap;
};
